import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export default makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      flexFlow: 'column nowrap',
    },
    header: {
      marginBottom: theme.spacing(1),
    },
    description: {
      color: COLORS.gray.gray40,
      marginTop: theme.spacing(0.5),
    },
    error: {},
    input: {
      '& input::placeholder': {
        fontSize: 'inherit',
        color: COLORS.gray.gray40,
      },
    },
  }),
  { name: 'FieldInput' }
);
